import { TripV2NoteCategory, TripV2NoteSubcategory } from 'gql/generated/graphql'
import { defineMessages } from 'react-intl'

export const noteCategoryMessages = defineMessages({
  [TripV2NoteCategory.Ambassador]: {
    id: 'tripNote.category.ambassador',
    defaultMessage: 'Ambassador'
  },
  [TripV2NoteCategory.BusinessClient]: {
    id: 'tripNote.category.businessClient',
    defaultMessage: 'Business client'
  },
  [TripV2NoteCategory.Cash]: {
    id: 'tripNote.category.cash',
    defaultMessage: 'Cash'
  },
  [TripV2NoteCategory.Driver]: {
    id: 'tripNote.category.driver',
    defaultMessage: 'Driver'
  },
  [TripV2NoteCategory.Events]: {
    id: 'tripNote.category.events',
    defaultMessage: 'Events'
  },
  [TripV2NoteCategory.ExternalConditions]: {
    id: 'tripNote.category.externalConditions',
    defaultMessage: 'External conditions'
  },
  [TripV2NoteCategory.Other]: {
    id: 'tripNote.category.other',
    defaultMessage: 'Other'
  },
  [TripV2NoteCategory.Partner]: {
    id: 'tripNote.category.partner',
    defaultMessage: 'Partner'
  },
  [TripV2NoteCategory.Passengers]: {
    id: 'tripNote.category.passengers',
    defaultMessage: 'Passengers'
  },
  [TripV2NoteCategory.Planning]: {
    id: 'tripNote.category.planning',
    defaultMessage: 'Planning'
  },
  [TripV2NoteCategory.Service]: {
    id: 'tripNote.category.service',
    defaultMessage: 'Service'
  },
  [TripV2NoteCategory.Tolls]: {
    id: 'tripNote.category.tolls',
    defaultMessage: 'Tolls'
  },
  [TripV2NoteCategory.Vehicle]: {
    id: 'tripNote.category.vehicle',
    defaultMessage: 'Vehicle'
  },
  [TripV2NoteCategory.DriverRsvp]: {
    id: 'tripNote.category.driverRsvp',
    defaultMessage: 'Pase de asistencia'
  }
})

export const noteSubcategoryMessages = defineMessages({
  [TripV2NoteSubcategory.Absence]: {
    id: 'tripNote.subcategory.absence',
    defaultMessage: 'Absence'
  },
  [TripV2NoteSubcategory.Accident]: {
    id: 'tripNote.subcategory.accident',
    defaultMessage: 'Accident'
  },
  [TripV2NoteSubcategory.Disability]: {
    id: 'tripNote.subcategory.disability',
    defaultMessage: 'Disability'
  },
  [TripV2NoteSubcategory.MechanicalFailure]: {
    id: 'tripNote.subcategory.mechanicalFailure',
    defaultMessage: 'Mechanical failure'
  },
  [TripV2NoteSubcategory.Other]: {
    id: 'tripNote.subcategory.other',
    defaultMessage: 'Other'
  },
  [TripV2NoteSubcategory.Protest]: {
    id: 'tripNote.subcategory.protest',
    defaultMessage: 'Protest'
  },
  [TripV2NoteSubcategory.Replacement]: {
    id: 'tripNote.subcategory.replacement',
    defaultMessage: 'Replacement'
  },
  [TripV2NoteSubcategory.Roadblock]: {
    id: 'tripNote.subcategory.roadblock',
    defaultMessage: 'Roadblock'
  },
  [TripV2NoteSubcategory.ScheduledMaintenance]: {
    id: 'tripNote.subcategory.scheduledMaintenance',
    defaultMessage: 'Scheduled maintenance'
  },
  [TripV2NoteSubcategory.Security]: {
    id: 'tripNote.subcategory.security',
    defaultMessage: 'Security'
  },
  [TripV2NoteSubcategory.Traffic]: {
    id: 'tripNote.subcategory.traffic',
    defaultMessage: 'Traffic'
  },
  [TripV2NoteSubcategory.UnitStoppage]: {
    id: 'tripNote.subcategory.unitStoppage',
    defaultMessage: 'Unit stoppage'
  },
  [TripV2NoteSubcategory.Weather]: {
    id: 'tripNote.subcategory.weather',
    defaultMessage: 'Weather'
  }
})
